var Cube = require('cube-js')
var HeaderController = require('./header.js');

class ImageLoader {

  init(w, h) {

    this.window_width = w;
    this.window_height = h;
    this._loadImage();
  }

  onResize(w, h) {
    this.window_width = w;
    this.window_height = h;
  }

  _loadImage() {
    Cube.forEach($('.smart-image'), (item, index) => {
      item = $(item);

      var src = item.data('src');
      var list = src.split('.');

      var index = list.length - 2;

      if (this.window_width >= 768) {
        // list[index] += '-1920'
      } else {
        list[index] += '-phone'
      }
      src = list.join('.');
      item.attr('src', src);
    });
  }
};

class App {

  run() {
    this.init();
    $(window).on('resize', () => {
      this.onResize();
    });
  }

  init() {

    this.updateSize();
    this.imageLoader = new ImageLoader();
    this.imageLoader.init(this.window_width, this.window_height);
  }

  reload() {
    location.reload(true);
  }

  onResize() {

    this.updateSize();

    if ((this.last_window_width - 768) * (this.window_width - 768) <= 0){
      this.reload();
      return;
    }
    this.last_window_width = this.window_width;

    this.imageLoader.onResize(this.window_width, this.window_height);
  }

  updateSize() {
    this.window_width = $(window).width();
    this.window_height = $(window).height();
  }
}

$(window).load(function(){
  var app = new App();
  app.run();
  new HeaderController();
});



//////////////////
// WEBPACK FOOTER
// ./src/js/global.js
// module id = 33
// module chunks = 1